import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthSevices, ClientService, ClientSubscriptionService, CommonService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { ClientById, InvoiceOccurance, SubscriptionCycleException, SubscriptionCycleExceptionRequest } from '@fitness-force/models';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { TableModule } from 'primeng/table';
import { BehaviorSubject } from 'rxjs';
import { AppErrors } from '@fitness-force/errors';
import { AvatarModule } from 'primeng/avatar';
import { RouteStateService } from '@fitness-force/shared';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { StyleClassModule } from 'primeng/styleclass';
import { MessageModule } from 'primeng/message';



@Component({
  selector: 'subscription-free-discount',
  templateUrl: './subscription-free-discount.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [   CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    SelectModule,
    InputTextModule,
    TableModule,
    ButtonModule,
    PopoverModule,
    DateTimeFormatPipe,
    CurrencyformatPipe,
    AvatarModule,
    ShortNamePipe,
    InputNumberModule,
    StyleClassModule,
    TranslateModule],
})
export class SubscriptionFreeDiscountComponent implements OnInit {
  @Input('visible') showDiscountPeriodPopup: boolean = false;
  @Input('subscriptionId') subscriptionId: number = 0;
  @Input('tenantId') tenantId: number = 0;
  @Input('clientId') clientId: number = 0;
  @Input('timelines') paymentTimelineData = new BehaviorSubject<InvoiceOccurance[]>([]);
  @Output('closePopup') emitEvents: EventEmitter<any> = new EventEmitter();

  billingCycles: any[];
  discountedPeriodTableData: any[];

  discountedPeriodForm: UntypedFormGroup;
  discountedPeriods: UntypedFormGroup[] = [];
  single_staff_discount = 0;
  recurring_staff_discount = 0;
  userDiscountLimit = 0;
  currentUserDetails: any;
  filteredTimelines = new BehaviorSubject<InvoiceOccurance[]>([]);
  btnLoading = new BehaviorSubject<Boolean>(false);
  clientDetails : ClientById | null;
  selectedOccurences:Array<InvoiceOccurance>= [];

  constructor(private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private cd: ChangeDetectorRef,
    private commonService: CommonService,
    public authService: AuthSevices,
    private clientSubscriptionService: ClientSubscriptionService,
    private toastMessageService: ToastMessageService,
    private storeService:RouteStateService,
    private timeService:TimeconversionService,
    private clientService: ClientService) 
    {
    this.currentUserDetails = this.authService.decodedToken;
    this.single_staff_discount = this.currentUserDetails.single_staff_discount;
    this.recurring_staff_discount = this.currentUserDetails.recurring_staff_discount;
  }

  ngOnInit(): void {
    // this.paymentTimelineData.value.forEach((o:InvoiceOccurance) => {
    //   o.occurance_start_date = this.ConvertUTCToLocalDateTime(o.occurance_start_date).toString();
    //   o.occurance_end_date = this.ConvertUTCToLocalDateTime(o.occurance_end_date).toString();
    // });

    if(this.subscriptionId > 0 && this.paymentTimelineData.value && this.paymentTimelineData.value.length == 0)
    {
      this.getPaymentTimeline();
    }

    this.filteredTimelines.next(this.paymentTimelineData.value.filter(o => o.occurance_invoice_id == 0));
    this.discountedPeriodForm = this.fb.group({
      discountReason: [''],
    });
    this.clientDetails = this.storeService.getClient() as ClientById;
    this.addDiscountedPeriod();
  }

  getPaymentTimeline() {
    this.clientService.getPaymentTimeline(
      this.clientId,
      this.subscriptionId
    ).subscribe({
      next: (response: any) => {
        this.paymentTimelineData.next(response.invoice_occurance ? response.invoice_occurance : []);
        this.filteredTimelines.next(this.paymentTimelineData.value.filter(o => o.occurance_invoice_id == 0));
        this.cd.detectChanges();
      },
      error: (error) => {
        this.paymentTimelineData.next([]);
        this.filteredTimelines.next(this.paymentTimelineData.value);
        this.cd.detectChanges();
      },
    });
  }

  addDiscountedPeriod(): void {
    const newDiscountedPeriod = this.fb.group({
      discountAcucrence: [null, Validators.required],
      discountTotalAmount: [null],
      discountedAmount: [0],
      discountValue: [{value:null,disabled: true}, Validators.required],
      discountPercent: [{value:null,disabled: true}, Validators.required],
    });
    newDiscountedPeriod.updateValueAndValidity();
    this.discountedPeriods.push(newDiscountedPeriod);
    for (const control of this.discountedPeriods) {
      control.updateValueAndValidity();
    }
    this.cd.detectChanges();
  }

  removeDiscountedPeriod(index: number, startDate:any): void {
    this.discountedPeriods.splice(index, 1);
    this.selectedOccurences.splice(this.selectedOccurences.findIndex(o => o.occurance_start_date === startDate), 1);
    this.cd.detectChanges();
  }

  setAccurence(discountedPeriod: FormGroup, occurence: InvoiceOccurance) {
    discountedPeriod.get('discountAcucrence')!.setValue(occurence);
    discountedPeriod.get('discountTotalAmount')!.setValue(occurence.payment_amount_in_minor_currency);
    discountedPeriod.get('discountedAmount')!.setValue(occurence.payment_amount_in_minor_currency);
    discountedPeriod.get('discountValue')!.setValidators(Validators.max(this.commonService.ConvertAmountFromMinorCurrency(occurence.payment_amount_in_minor_currency)));
    discountedPeriod.get('discountValue')!.enable();
    discountedPeriod.get('discountPercent')!.enable();
    this.discountedPeriodForm.controls["discountReason"].setValidators(Validators.required);
    this.discountedPeriodForm.controls["discountReason"].updateValueAndValidity();
    this.selectedOccurences.push(occurence);
    //this.filteredTimelines.next(this.paymentTimelineData.value.filter(o => o.occurance_start_date !== occurence.occurance_start_date && o.occurance_invoice_id == 0));
    this.cd.detectChanges();
  }

  calculateDiscount(accurenceAmountCtrl: UntypedFormControl, amtCtrl: UntypedFormControl, disCtrl: UntypedFormControl,disountedCtrl: UntypedFormControl) {
    let accurenceAmount: number = this.commonService.ConvertAmountFromMinorCurrency(accurenceAmountCtrl.value);
    if (
      accurenceAmount -
      (accurenceAmount * this.recurring_staff_discount) / 100 <=
      amtCtrl.value &&
      accurenceAmount >= amtCtrl.value && (amtCtrl.value / accurenceAmount) * 100 <= Number(this.recurring_staff_discount)
    )
    {
    // if (parseInt(amtCtrl.value)  <= discountedAmount  && accurenceAmount >= parseInt(amtCtrl.value)) {
      disCtrl.setValue((amtCtrl.value / accurenceAmount) * 100);
      disountedCtrl.setValue(this.commonService.ConvertMinorCurrencyFromAmount(accurenceAmount - amtCtrl.value));
    } else {
          setTimeout(() => {
          this.userDiscountLimit = this.recurring_staff_discount;
          amtCtrl.setValue(0);
          disCtrl.setValue(0);
          disountedCtrl.setValue(accurenceAmountCtrl.value);
          amtCtrl.setErrors({ singstaffdiscount: true });
          this.translate
              .get('FREEDISCOUNT.DISCOUNT_ERROR',{perc:this.userDiscountLimit})
              .subscribe((translation) => {
                this.toastMessageService.showErrorMessage(translation);
              });
        }, 10);
    }
  }

  calculateAmount(accurenceAmountCtrl: UntypedFormControl, amtCtrl: UntypedFormControl, disCtrl: UntypedFormControl,disountedCtrl: UntypedFormControl) {
    let accurenceAmount: number = this.commonService.ConvertAmountFromMinorCurrency(accurenceAmountCtrl.value);
    let netValue = accurenceAmount - (accurenceAmount * disCtrl.value) / 100;
    if (accurenceAmount - (accurenceAmount * this.recurring_staff_discount) / 100 <= netValue) {
      let discountedAMlunt =(accurenceAmount * disCtrl.value) / 100;
      amtCtrl.setValue(discountedAMlunt);
      disountedCtrl.setValue(this.commonService.ConvertMinorCurrencyFromAmount(accurenceAmount - amtCtrl.value));
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.recurring_staff_discount;
        amtCtrl.setValue(0);
        disCtrl.setValue(0);
        disountedCtrl.setValue(this.commonService.ConvertMinorCurrencyFromAmount(accurenceAmountCtrl.value));
        disCtrl.setErrors({ singstaffdiscount: true });
        this.translate
        .get('FREEDISCOUNT.DISCOUNT_ERROR',{perc:this.userDiscountLimit})
        .subscribe((translation) => {
          this.toastMessageService.showErrorMessage(translation);
        });
      }, 10);
    }
  }

  isDiscountedPeriodsValid(): boolean {
    let isValid: boolean = false;
    for (const control of this.discountedPeriods) {
      if (!(control instanceof FormGroup) || !control.valid) {
        isValid = false; // If any FormGroup is invalid, disable the button
      }
      else isValid = true;
    }
    return isValid; // If all FormGroups are valid, enable the button
  }

  onSubmit(): void {
    this.btnLoading.next(true);
    if(this.discountedPeriodForm.valid && this.isDiscountedPeriodsValid())
    {
      const formValues = {
        ...this.discountedPeriodForm.value,
        discountedPeriods: this.discountedPeriods.map((period) => period.value),
      };
      let payload: SubscriptionCycleExceptionRequest = {} as SubscriptionCycleExceptionRequest;
      payload.subscription_cycle_exception = [];
      let discountedPeriods = formValues["discountedPeriods"];
     
      discountedPeriods.forEach((period: any) => {
          let accurence:SubscriptionCycleException ={} as SubscriptionCycleException;
          accurence.discount_occurence = period["discountAcucrence"].occurance;
          accurence.discount_amount = this.commonService.ConvertMinorCurrencyFromAmount(Math.round(period.discountValue));
          accurence.discount_reason = formValues["discountReason"];
          payload.subscription_cycle_exception.push(accurence);
      });
      this.clientSubscriptionService.MidCycleDiscount(this.tenantId, this.clientId, this.subscriptionId, payload)
        .subscribe({
          next: (data: any) => {
            this.translate
              .get('FREEDISCOUNT.SUCCESS_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.discountedPeriodForm.reset();
            this.btnLoading.next(false);
            this.emitEvents.emit(true);
            this.closePopup();
          },
          error: (error: AppErrors) => {
            this.btnLoading.next(false);
            this.toastMessageService.showError(error);
          },
        });
    }
    else{
      Object.keys(this.discountedPeriodForm.controls).forEach((field) => {
        const control = this.discountedPeriodForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      for (const control of this.discountedPeriods) {
        control?.markAsTouched({ onlySelf: true });
      }
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading.next(false);
      this.cd.detectChanges();
    }
    
  }

  client2LetterName(name: string): string {
    if (name) {
      const nameArray = name.split(' ');
      const newNameArray = [];
      for (let i = 0; i < nameArray.length; i++) {
        if (newNameArray.length >= 2) break;

        if (nameArray[i]) {
          newNameArray.push(nameArray[i]);
        }
      }
      return newNameArray.join(' ');
    } else {
      return '';
    }
  }

get getOccurences() {
  if(this.selectedOccurences.length > 0)
    return this.filteredTimelines.value.filter(o => !this.selectedOccurences.some((occurence:InvoiceOccurance) => occurence.occurance_start_date === o.occurance_start_date && occurence.occurance_invoice_id === 0));
  else return this.filteredTimelines.value;
}

  closePopup() {
    this.emitEvents.emit(false);
  }

  ConvertUTCToLocalDateTime(date: Date | string): Date {
    let localDate = new Date(date);
    return localDate;
  }

  convertLoaclToUtc(date:Date | string)
  {
    return new Date(date).toISOString();
  }

}